const config: Highcharts.Options = {
  chart: {
    type: 'line',
  },

  series: [
    {
      name: 'A',
      type: 'line',
      color: '#01589F',
      data: [1, 2, 5, 4, 8, 9],
    },
    {
      name: 'B',
      type: 'line',
      color: 'green',
      data: [1, 5, 0, 3, 7, 20],
    },
  ],
  xAxis: {
    gridLineColor: 'transparent',
    categories: ['1', ' 5', '10', '15', '20', '25'],
    lineColor: '#CECEDC',
    title: {
      text: '',
      style: {
        fontFamily: 'Inter',
        fontWeight: '500',
        fontSize: '13px',
        lineHeight: '16px',
        color: '#ADADBF',
      },
    },
    labels: {
      style: {
        fontFamily: 'Inter',
        fontWeight: '500',
        fontSize: '11px',
        lineHeight: '16px',
        color: '#ADADBF',
      },
    },
    opposite: false,
    reversed: false,
  },
  yAxis: {
    gridLineWidth: 0,
    lineWidth: 1,
    lineColor: '#CECEDC',
    title: {
      text: '',
      style: {
        fontFamily: 'Inter',
        fontWeight: '500',
        fontSize: '13px',
        lineHeight: '16px',
        color: '#ADADBF',
      },
    },
    labels: {
      style: {
        fontFamily: 'Inter',
        fontWeight: '500',
        fontSize: '11px',
        lineHeight: '16px',
        color: '#ADADBF',
      },
    },
    opposite: false,
    reversed: false,
  },
};

export default config;
